import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // Email categories
    addTechnicalServiceData(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/technical-service', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateTechnicalServiceData(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/technical-service/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteTechnicalServiceData(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/technical-service/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTechnicalServiceDatas(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/technical-service', { params: data })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTechnicalServiceData(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/technical-service/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
